import { Component } from '@angular/core';
import { ICCService } from './icc.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../common/global-variables';
import { VcaAlertsService } from '../../../../common/vca-alerts/vca-alerts.service';
import { Subscription } from 'rxjs/Rx';
import { RefreshSharedService } from '../../../refresh-shared-service';
import { AuthService } from '../../../auth/auth.service';
import { FleetConfiguration } from './model/fleet-configuration';
import { NetworkProfile } from './model/network-profile';
import { Util } from './utils';

const _ = require('lodash');
const SUCCESS = 'SUCCESS';
const FAILED = 'FAILED';

@Component({
    selector: 'interconnect-configuration-landing',
    styles: [require('./icc.scss')],
    templateUrl: './icc-landing.html'
})

export class InterConnectConfigurationLanding {

    private fleetConfiguration: FleetConfiguration;
    private deploymentContainerData: any = [];
    private isTranslationready: boolean = true;
    private isLoading: boolean = true;
    private rsService: RefreshSharedService;
    private refreshSubscription: Subscription;
    private currentClassName: string = '';
    private canAdd: boolean = true;
    private canDelete: boolean = false;
    private canEdit: boolean = false;
    private isAddEditDialogOpen: boolean = false;
    private isEditInProgress: boolean = false;
    private isReadOnly: boolean = true;
    private selectedDeploymentContainer: any;
    private showDeleteDialog: boolean = false;
    private editData: any;
    private isEdit: boolean = false;
    private isSystemAdmin: boolean = false;
    private isGlobalDeploymentContainer: boolean = false;
    private globalDeploymentContainerVc: string = '';
    private openWizardinEditMode: boolean = false;
    //New
    private fleetConfigList: Array<FleetConfiguration> = new Array<FleetConfiguration>();
    private deploymentContainerList: Array<Object>;
    private vcList: Array<Object> = new Array<Object>();
    private combinedData: Array<Object>;

    private isFleetConfigDataReady: boolean = false;
    private isDeploymentContainerDataReady: boolean = false;
    private isVCDataReady: boolean = false;

    private canShowListing: boolean = false;
    private isWizardOpen: boolean = false;
    private isDeleteInProgress: boolean = false;
    private showTransformDialog: boolean = false;
    private subscribeHandler: Subscription;
    private transformUpdateMessage:string = '';
    private isTransformIsInProgress: boolean = false;
    private isTransformSucceded: boolean = false;
    private isInterconnectConfigConvertedToSM: boolean = false;
    private transformData: any = {
        "isTransformIsInProgress" : false,
        "transformResult": '',
        "message": ""
    }

    private siteId: string = '';
    private objectKeys = Object.keys;
    private itemToDel: string = '';
    private networkTypes = {
        vmotionNetwork: 'VMotion Network',
        externalNetwork: 'External Network',
        managementNetwork: 'Management Network',
        directConnectNetwork1: 'Direct Connect Network 1',
        directConnectNetwork2: 'Direct Connect Network 2'
    };
    private showEditNetworkDialog: boolean = false;
    private showDeleteNetworkDialog: boolean = false;
    private selectedResourceDetails: any;
    private showAddNetworkDialog: boolean = false;
    private showDeleteConfigDialog: boolean = false;
    private selected_fleetConfig: any;
    private selecteSiteId: string = '';
    private selectedConfigName: string = '';
    private isDeleteCallInProgress: boolean = false;
    private deleteOperationFailed: boolean = false;
    private errorMessage: string = '';
    private selecteResourceId: string = '';
    private showIntroduction: boolean = false;
    private isGetConfigInProgress: boolean = false;

    constructor(private service: ICCService, private translate: TranslateService, private alert: VcaAlertsService, private rss: RefreshSharedService,
        public authService: AuthService) {
        translate.use(GlobalVariables.LOCALE);
        this.rsService = rss;
        this.currentClassName = 'InterConnectConfigurationLanding';
        let roles = (this.authService.loggedInUserInfo && this.authService.loggedInUserInfo.roles) ? this.authService.loggedInUserInfo.roles : [];
        if (_.includes(roles, 'System Administrator')) {
            this.isSystemAdmin = true;
        }
        this.siteId = this.authService.endpointInfo ? this.authService.endpointInfo.uuid : '';
    }

    public ngOnInit() {
        this.refreshSubscription = this.rsService.getRefreshParam()
            .subscribe(
                item => {
                    this.handleEmittedValues(item);
                });

        this.rsService.setParam({
            'loadedComponent': this.currentClassName,
            'detailPageIDName': '',
            'shouldReloadInventoryTree': false
        });
        this.getAllVCs();
        if(this.isSystemAdmin){
            this.getDeploymentContainers();
        }
        this.getFleetConfig();
    }

    private getFleetConfig() {
        this.isFleetConfigDataReady = false;
        this.isLoading = true;
        this.showIntroduction = false;
        this.isInterconnectConfigConvertedToSM = false;
        this.service.getFleetConfig(this.siteId)
            .subscribe(
                data => {
                    this.fleetConfigList = new Array<FleetConfiguration>();
                    for(let i:number =0;i<data.resourceDetails.length;++i){
                        var fleetConfig:FleetConfiguration = Util.convertToFleetConfig(data.resourceDetails[i])
                        this.fleetConfigList.push(fleetConfig);
                        if(fleetConfig.smEnabledStatus === "SUCCESS"){
                            this.isInterconnectConfigConvertedToSM = true;
                        }
                    }
                    this.isLoading = false;
                    this.isFleetConfigDataReady = true;
                    if(this.fleetConfigList.length > 0){
                        this.showIntroduction = false;
                        this.showListing();
                    } else {
                        this.showIntroduction = true;
                    }
                },
                error => {
                    this.alert.danger(['Failed to retrieve Fleet Config', error], 'vcenter-grid');
                    this.isLoading = false;
                }
            );
    }

    private handleEmittedValues(data){

    }

    private getDeploymentContainers() {
        // admin/hybridity/api/fleetConfig/site/siteId
        this.isDeploymentContainerDataReady = false;
        this.deploymentContainerList = [];
        this.isLoading = true;
        this.service.getDeploymentContainers()
            .subscribe(
                (data:any) => {
                    this.deploymentContainerList = data;
                    this.isLoading = false;
                    this.isDeploymentContainerDataReady = true;
                    this.showListing();
                },
                error => {
                    this.alert.danger(['Failed to retrieve DeploymentContainers', error], 'vcenter-grid');
                    this.isLoading = false;
                }
            );
    }

    private getAllVCs() {
        this.isVCDataReady = false;
        this.vcList = [];
        this.isLoading = true;
        this.service.getVcList()
            .subscribe(
                (data:any) => {
                    this.vcList = data;
                    this.isLoading = false;
                    this.isVCDataReady = true;
                    this.showListing();
                },
                error => {
                    this.alert.danger(['Failed to retrieve VCenters', error], 'vcenter-grid');
                    this.isLoading = false;
                }
            );
    }

    private showListing() {
        if (!this.isFleetConfigDataReady ||
            !this.isDeploymentContainerDataReady ||
            !this.isVCDataReady) {
            return;
        }
        //this.processData();
        this.canShowListing = true;
    }

    private getDeploymentContainerName(deploymentContainerId) {
        for (let i = 0; i < this.deploymentContainerList.length; i++) {
            if (this.deploymentContainerList[i]['id'] === deploymentContainerId) {
                return {
                    'deploymentContainerName': this.deploymentContainerList[i]['name'],
                    'vCenterInstanceUuid': this.deploymentContainerList[i]['vCenterInstanceUuid']
                }
            }
        }
    }

    private getVCName(vCenterInstanceUuid) {
        for (let i = 0; i < this.vcList.length; i++) {
            if (this.vcList[i]['vcenter_instanceId'] === vCenterInstanceUuid) {
                return this.vcList[i]['name'];
            }
        }
    }

    private ngOnDestroy() {
        this.rsService.resetParam();
        if (this.refreshSubscription) {
            this.refreshSubscription.unsubscribe();
        }
    }


    private showAddWizard() {
        this.isEdit = false;
        this.fleetConfiguration = new FleetConfiguration();
        this.fleetConfiguration.networkProfiles.push(Util.getEmptyNetworkProfiles());
        this.isWizardOpen = true;
    }

    private wizardStatusChange() {
        this.isWizardOpen = false;
    }

    onDeleteConfig(exisitngFleetConfig) {
        this.selecteResourceId = exisitngFleetConfig.vcenterInstanceId;
        this.selectedConfigName = exisitngFleetConfig.name ? exisitngFleetConfig.name : exisitngFleetConfig.resourceId;
        this.showDeleteConfigDialog = true;
    }

    private onDeleteConfigDialogCancel() {
        this.showDeleteConfigDialog = false;
        this.deleteOperationFailed = false;
    }

    onDeleteConfigDialogSave(resourceId) {
        this.isDeleteCallInProgress = true;
        this.service.deleteFleetConfigByResourceId(resourceId).subscribe(
            () => {
                this.isDeleteCallInProgress = false;
                this.showDeleteConfigDialog = false;
                this.deleteOperationFailed = false;
                this.getFleetConfig();
            },
            error => {
                this.isDeleteCallInProgress = false;
                this.deleteOperationFailed = true;
                this.errorMessage = Util.getErrorMessage(error);
            }
        );
    }

    private openEditWizard(resourceId:string){
        this.isEdit = true;
        this.service.getInterConnectConfig(resourceId).subscribe(
                (data) => {
                    let fleetConfig:FleetConfiguration = Util.convertToFleetConfig(data);
                    if(fleetConfig.clusterId === undefined || fleetConfig.clusterId === ''){
                        this.isGetConfigInProgress = true;
                        this.service.getResourcePools(fleetConfig.vcenterInstanceId).subscribe(
                            (resourcePools:any) => {
                                for (let resourcePool of resourcePools){
                                    if(resourcePool.entity_id === fleetConfig.resourcePoolId) {
                                        if(resourcePool.hasOwnProperty('owner')){
                                            fleetConfig.clusterId = resourcePool.owner.value;
                                        } else if(resourcePool.hasOwnProperty('parent')){
                                            fleetConfig.clusterId = resourcePool.parent.value;
                                        }
                                        break;
                                    }
                                }
                                this.isGetConfigInProgress = false;
                                this.fleetConfiguration = fleetConfig;
                                this.isWizardOpen = true;
                            },
                            (error) => {
                                fleetConfig.clusterId = '';
                                this.isGetConfigInProgress = false;
                            }
                        )
                    } else {
                        this.fleetConfiguration = fleetConfig;
                        this.isWizardOpen = true;
                    }
                },
                (error) => {
                    this.alert.danger(Util.getErrorMessage(error), 'vcenter-grid');
                    this.isLoading = false;
                }
            );
    }

    private onAddEditOperationComplete(){
        this.getFleetConfig();
    }

    private showTransformConfirmation() {
        this.showTransformDialog = true;
    }

    private closeTransformDialog(){
        this.showTransformDialog = false;
    }

    private transformFleetConfig(){
        this.resetTransformData();
        this.transformData.isTransformIsInProgress = true;
        this.service.transformInterconnectConfigToServiceMesh().subscribe(
            (res:any) => {
                this.updateTransformStatus(res.data.interconnectTaskId);
            },
            (error) => {
                this.transformData.transformResult = FAILED;
                this.transformData.message = '';
                for( let errorMessage in error){
                    this.transformData.message += this.transformData.message + "</br>";
                }
            }
        )
        this.showTransformDialog = false;
    }

    private resetTransformData(){
        this.transformData.transformResult = '';
        this.transformData.message = '';
    }

    private updateTransformStatus(interconnectTaskId:string){
        this.subscribeHandler = this.service
        .getInterconnectTaskById(interconnectTaskId)
        .subscribe((response:any) => {
            this.transformData.message = response.message;
            if ( response.status === SUCCESS || response.status === FAILED) {
                this.transformData.isTransformIsInProgress = false;
                this.transformData.transformResult = response.status;
                this.subscribeHandler.unsubscribe();
                this.isTransformIsInProgress = false;
                if(response.status === FAILED){
                    this.transformData.message = '';
                    for( let error of response.response.errors){
                        this.transformData.message += error.message;
                    }
                }
            }
        },
        (error) => {
            this.transformData.transformResult = FAILED;
            if(error.hasOwnProperty('_body')){
                this.transformData.message = error;
            }
        }
        );

    }

}


// WEBPACK FOOTER //
// ./src/app/components/administration-main/interconnect-configuration/icc-landing.component.ts